import { render, staticRenderFns } from "./imagePopup.vue?vue&type=template&id=3707a7d4&"
import script from "./imagePopup.vue?vue&type=script&lang=ts&"
export * from "./imagePopup.vue?vue&type=script&lang=ts&"
import style0 from "./imagePopup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports